<!--  -->
<template>
  <div ref="print"> 
    <div style="width: 100%;text-align: center; margin-bottom:5px"><h4>{{paperInfo.title}}</h4></div>
    <div style="width: 100%;text-align: center;"><p class="text-muted mb-0">{{paperInfo.remarks}}&nbsp;&nbsp;(&nbsp;满分{{paperInfo.totalscore}}分，考试时间{{paperInfo.duration}}分钟&nbsp;)</p></div>
    <div> 
        <div v-for="(bigQust,bigindex) in bigQusts" :key="bigindex"> 
            <div class="test_content">
                <div class="test_printcontent_title">
                    <p><span class="h2">{{NoToChinese(bigindex+1)}}&nbsp;.{{bigQust.title}}</span>(<span v-if="bigQust.remarks">{{bigQust.remarks}},</span>共{{bigQust.selectedtopics.length}}题，合计{{bigQust.totalscore}}分)
                    </p>
                </div>
            </div>
            <div class="test_printcontent_nr">
                <ul>
                    <li v-for="(qust,index) in bigQust.detailexs" :key="index" :id="`qu_${bigindex}_${index}`"  >
                        <div class="test_printcontent_nr_tt" v-if="bigQust.type!='复合题'">
                            <font style="color: #000;">{{index+1}}&nbsp;.&nbsp;{{qust.title}}</font>
                            <br v-if="qust.filepath"/> <img v-if="qust.filepath" :src="`${global.remoteIp}/uploads/${qust.filepath}`" alt="" style="width: 60%;">
                            <br v-if="qust.filepath"/><br v-if="qust.filepath"/>
                        </div>
                        <div class="test_printcontent_nr_tt" v-else>
                            <font style="color: #000;">{{index+1}}&nbsp;.&nbsp;<p v-html="qust.title"></p></font>
                        </div>
                        <div class="test_printcontent_nr_main" v-loading="!bigQust.ishow">
                            <ul v-if="qust.foption">
                                <li v-for="(option,indexex) in qust.foption.split(',jh,')" :key="indexex" style=" display:inline;margin-right: 25px">
                                    <label :for="`0_answer_${index}_option_${indexex}`" style="font-weight:500">
                                        {{option.slice(0,2)}}
                                        <p  style="display: inline;">{{option.slice(2)}}</p>
                                    </label>
                                </li>
                            </ul>
                        </div>
                         <div>
                            <span class="text-success mb-1 " style="padding-left: 20px;" v-if="qust.record.correctanswer">[ 正确答案：{{qust.record.correctanswer}} ]</span>
                            <span class="text-danger mb-1 mb-1" style="padding-left: 20px;">[ 考生答案：{{qust.record.useranswer}} ]</span>
                            <img v-bind:src="'/static/images/'+qust.record.result+'.png'" width="30px;" />
                            <template v-if="'1' == qust.record.result"><b>+&nbsp;{{qust.record.score}}</b>&nbsp;分</template>
                        </div>
                        <div>
							<template><span class="text-primary mb-1" style="padding-left: 20px;">[ 答案解析：{{qust.remarks}} ]</span></template>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div width="100%" style="text-align:center;">
            <el-button type="success"  @click="$router.go(-1)">返回</el-button>
        </div>
    </div>
  </div>
</template>

<script>
import global from "../components/PublicComs/Common.vue";
export default {
       metaInfo: {
       meta: [
        { name:'viewport', content:
        `width=device-width, user-scalable=no, initial-scale=${1.0}, maximum-scale=${1.0}, minimum-scale=${1.0}`}
      ]
    },

  beforeDestroy() {
     document
      .querySelector("body")
      .setAttribute(
        "style",
        'font-family:Verdana;background: url("/static/images/bg.png");background-repeat: no-repeat;background-attachment: fixed;background-position: center;background-size: cover;-webkit-background-size: cover;-moz-background-size: cover;-o-background-size: cover;'
      );
  },
  data () {
    return {
        bigQusts:[],
        paperInfo:{},
        global
    };
  },
  components: {},

  computed:{},

  mounted(){
      document
      .querySelector("body")
      .setAttribute(
        "style",
        'font-family:Verdana;background: #fff'
      );
    if(this.$route.params.id)
    {
        this.$axios.get(`/api/examRecords/getFormalQuestionInfo/${this.$route.params.id}`).then(res => {
            if(res.data)
            {
                this.paperInfo = res.data.testPaper;
                this.bigQusts = res.data.testPaper.testPaperInfos;
                 let arrQustRecodes = res.data.data;
                for(let i=0;i<this.bigQusts.length;i++)
                {
                    this.bigQusts[i].ishow = false;
                    this.$forceUpdate();
                    this.$axios.get(`/api/students/testPapers/${this.paperInfo._id}/testPaperInfos/${this.bigQusts[i]._id}`).then(res => {
                        if(res.data)
                        {
                            this.bigQusts[i].detailexs= res.data.questionInfo;
                            this.bigQusts[i].ishow = true;
                            if(!this.bigQusts[i].detailexs)
                            {
                                this.bigQusts[i].detailexs =[];
                            }
                            for(let j=0;j<this.bigQusts[i].detailexs.length;j++){
                                let qust = this.bigQusts[i].detailexs[j];
                                for(let k=0;k<arrQustRecodes.length;k++)
                                {
                                    if(qust._id==arrQustRecodes[k].questionid)
                                    {
                                        this.bigQusts[i].detailexs[j].record = arrQustRecodes[k];
                                        break;
                                    }
                                }
                            }
                            this.$forceUpdate();
                        }
                    });
                }
            }
        })
        
    }
  },

  methods: {
    //阿拉伯数字转中文数字
    NoToChinese(num) {
        if (!/^\d*(\.\d*)?$/.test(num)) {
            alert("Number is wrong!");
            return "Number is wrong!";
        }
        var AA = new Array("零", "一", "二", "三", "四", "五", "六", "七", "八", "九");
        var BB = new Array("", "十", "百", "千", "万", "亿", "点", "");
        var a = ("" + num).replace(/(^0*)/g, "").split("."),
            k = 0,
            re = "";
        for (var i = a[0].length - 1; i >= 0; i--) {
            switch (k) {
                case 0:
                    re = BB[7] + re;
                    break;
                case 4:
                    if (!new RegExp("0{4}\\d{" + (a[0].length - i - 1) + "}$").test(a[0]))
                        re = BB[4] + re;
                    break;
                case 8:
                    re = BB[5] + re;
                    BB[7] = BB[5];
                    k = 0;
                    break;
            }
            if (k % 4 == 2 && a[0].charAt(i + 2) != 0 && a[0].charAt(i + 1) == 0) re = AA[0] + re;
            if (a[0].charAt(i) != 0) re = AA[a[0].charAt(i)] + BB[k % 4] + re;
            k++;
        }
        if (a.length > 1) //加上小数部分(如果有小数部分) 
        {
            re += BB[6];
            for (var i = 0; i < a[1].length; i++) re += AA[a[1].charAt(i)];
        }
        return re;
    },
    print(){
        this.$print(this.$refs.print)
    }
  }
}

</script>
<style lang="scss" scoped>
.hasBeenAnswer {
	background: #5d9cec;
	color:#fff;
}
.cuowu:hover{

color: red;

}
.zhengque:hover{
color: rgb(16, 211, 42);	
}
@import "@/assets/css/iconfont.scss";
@import "@/assets/css/test.scss";
@import "@/assets/css/main.scss";

</style>